export default __webpack_public_path__ + "static/media/logo.c5bee6ad.svg";